import { DateInput } from "@equidefi/ui/forms";
import type { DateInputProps } from "@equidefi/ui/forms/DateInput";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartDateInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<DateInputProps, "name" | "value" | "onChange" | "error" | "isInvalid"> & {
  name: TName;
};

function SmartDateInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...dateProps }: SmartDateInputProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({ name, control });

  return (
    <DateInput
      name={field.name}
      ref={field.ref}
      value={field.value ?? ""}
      onChange={field.onChange}
      isInvalid={!!error}
      error={error?.message}
      {...dateProps}
    />
  );
}

export default SmartDateInput;
